export default __webpack_public_path__ + "static/media/icon-red-cross.76f36b95.svg";